@import '../../../tokens/dist/media-queries.css';

@keyframes fade {
	from {
		opacity: 0;
	}

	to {
		opacity: 1;
	}
}

@keyframes zoom {
	from {
		transform: scale(0.8);
	}

	to {
		transform: scale(1);
	}
}

@keyframes slide {
	from {
		transform: translateX(100%);
	}

	to {
		transform: translateX(0);
	}
}

@keyframes sheet {
	from {
		transform: translateY(100%);
	}

	to {
		transform: translateY(0);
	}
}

.base {
	border-radius: var(--lp-border-radius-medium);
	background-color: var(--lp-color-bg-overlay-primary);
	outline: none;
	padding: var(--lp-spacing-700);
	box-shadow:
		0px 0px 16px 0px var(--lp-color-shadow-ui-secondary),
		0px 8px 36px 0px var(--lp-color-shadow-ui-primary);

	& [slot='title'] {
		font: var(--lp-text-heading-1-semibold);
		grid-column: 1;
	}

	& [role='dialog']:has([slot='body']) {
		display: flex;
		flex-direction: column;
		gap: var(--lp-spacing-600);
		height: 100%;
	}

	& [slot='header'] {
		display: grid;
		grid-template-columns: 1fr;
		align-items: center;
		gap: var(--lp-spacing-300);

		& button[data-rac] {
			grid-column: 2;
		}
	}

	& [slot='body'] {
		overflow: auto;
		flex: 1;
	}

	& [slot='footer'] {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		gap: var(--lp-size-10);
	}

	& [slot='subtitle'] {
		font: var(--lp-text-body-1-regular);
		color: var(--lp-color-text-ui-secondary);
		grid-row: 2;
		grid-column: 1 / span 2;
	}
}

.defaultSmall {
	width: var(--lp-size-480);
}

.defaultMedium {
	width: var(--lp-size-640);
}

.large {
	width: var(--lp-size-800);
}

.drawerSmall {
	width: var(--lp-size-400);
}

.drawerMedium {
	width: var(--lp-size-560);
}

.default {
	@media (prefers-reduced-motion: no-preference) {
		&[data-entering] {
			animation-name: zoom;
			animation-duration: var(--lp-duration-200);
			animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
		}
	}
}

.drawer {
	position: fixed;
	top: 0;
	bottom: 0;
	right: 0;

	@media (prefers-reduced-motion: no-preference) {
		&[data-entering] {
			animation-name: slide;
			animation-duration: var(--lp-duration-300);
		}

		&[data-exiting] {
			animation-name: slide;
			animation-duration: var(--lp-duration-300);
			animation-direction: reverse;
			animation-timing-function: ease-in;
		}
	}
}

.overlay {
	position: fixed;
	inset: 0;
	width: 100vw;
	height: var(--visual-viewport-height);
	background: var(--lp-color-black-500);
	backdrop-filter: blur(1px);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: var(--lp-z-index-500);

	@media (prefers-reduced-motion: no-preference) {
		&[data-entering] {
			animation-name: fade;

			&:has(.default) {
				animation-duration: var(--lp-duration-200);
			}

			&:has(.drawer) {
				animation-duration: var(--lp-duration-300);
			}
		}

		&[data-exiting] {
			animation-name: fade;
			animation-direction: reverse;
			animation-timing-function: ease-in;

			&:has(.default) {
				animation-duration: var(--lp-duration-200);
			}

			&:has(.drawer) {
				animation-duration: var(--lp-duration-300);
			}
		}
	}
}

@media not (--tablet) {
	.base {
		width: 100vw;

		& [slot='footer'] {
			align-items: stretch;
			flex-direction: column-reverse;
		}
	}

	.default {
		position: fixed;
		bottom: 0;
		border-radius: 0;

		@media (prefers-reduced-motion: no-preference) {
			&[data-entering] {
				animation-name: sheet;
				animation-duration: var(--lp-duration-200);
				animation-timing-function: ease-in;
			}

			&[data-exiting] {
				animation-name: sheet;
				animation-duration: var(--lp-duration-200);
				animation-direction: reverse;
				animation-timing-function: ease-in;
			}
		}
	}
}
